import {axiosInstanceWithToken} from '../utils/Client';

export default class CompensationProfileService {
    static userList = async (locationId) => {
        return await axiosInstanceWithToken.get(`/users_except_agency_monitor/${locationId}/`);
    };

    static compensationList = async (userId) => {
        return await axiosInstanceWithToken.get(`compensation/list/${userId}/`);
    };

    static performanceRange = async (compensationId) => {
        return await axiosInstanceWithToken.get(
            `compensation/performance_range/${compensationId}/`,
        );
    };

    static savePerformance = (performanceData, compensationId) => {
        return axiosInstanceWithToken.put(
            `compensation/performance_range/${compensationId}/`, performanceData,
        );
    };

    static statementData = async (compensationId) => {
        return await axiosInstanceWithToken.get(`/compensation/statement/${compensationId}/`);
    };

    static saveStatementData = (statementData, compensationId) => {
        return axiosInstanceWithToken.put(
            `compensation/statement/${compensationId}/`, statementData
        );
    };

    static compensationKpi = async (compensationId, iw=0) => {
        if (!iw) {
            iw = 0;
        }
        return await axiosInstanceWithToken.get(
            `/compensation/kpi/list/${compensationId}/?iw=${iw}`
        );
    };

    static saveNewCompensationKpi = (compensationId, KpiData) => {
        return axiosInstanceWithToken.post(
            `compensation/kpi/${compensationId}/`, KpiData,
        );
    };

    static saveCompensationKpi = (KpiData) => {
        return axiosInstanceWithToken.put(
            `compensation/kpi/edit/${KpiData.id}/`, KpiData,
        );
    };

    static deleteCompensationKpi = (compKpiId) => {
        return axiosInstanceWithToken.delete(`compensation/kpi/edit/${compKpiId}/`);
    };

    static copyCompensationKpi = async (CompKpiList, compensationId) => {
        return await axiosInstanceWithToken.post(
            `/compensation/kpi/copy/${compensationId}/`, CompKpiList,
        );
    };

    static deleteCompensationAllKpi = async (compensationId) => {
        return await axiosInstanceWithToken.delete(
            `/compensation/kpi/delete/${compensationId}/`
        );
    };

    static reorderCompensationKpi = async (CompKpiList, compensationId) => {
        return await axiosInstanceWithToken.put(
            `/compensation/kpi/reorder/${compensationId}/`, CompKpiList,
        );
    };

    static getCompensation = async (compensationProfileId) => {
        return await axiosInstanceWithToken.get(`/compensation/${compensationProfileId}/`);
    };

    static saveCompensation = async (compensationData, compensationProfileId) => {
        return await axiosInstanceWithToken.put(
            `/compensation/${compensationProfileId}/`, compensationData,
        );
    };

    static getReportDetails = async (compensationProfileId) => {
        return await axiosInstanceWithToken.get(
            `/compensation/report/toggle/${compensationProfileId}/`,
         );
    };

    static setReportDetails = async (compensationProfileId, reportDetails) => {
        return await axiosInstanceWithToken.put(
            `/compensation/report/toggle/${compensationProfileId}/`, reportDetails
        );
    };

    // Get Agency Goal
    static getAgencyGoal = async (plProfileId) => {
        return await axiosInstanceWithToken.get(`/agency_goal/${plProfileId}/`);
    };
}




// WEBPACK FOOTER //
// ./src/services/CompensationProfileService.js